import styled from 'styled-components';

export const KycContainer = styled.div`
    h3,
    h3:first-child {
        margin: 0 0 20px;
        font-size: 18px;
    }

    .loader-wrapper {
        margin-top: 20px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/kyc/ConfirmationEbonPageKycBlocStyle.js